import "./base/gsap";

import { runDefault, runLayoutDefault, runComponentDefault, runModuleDefault } from "./utils/runner-functions";

import { initVariables, inner } from "./utils/variables";
import { initScroller, requestScrollTriggerRefresh } from "./base/scroll";
import { breakpoints } from "@tokens/breakpoints";
// import { runLoader } from "./base/loader";

async function init() {
    initGlobalScripts();
    initLayoutScripts();
    initComponentScripts();
    initModuleScripts();

    // await runLoader();
    // Animations after loader
    if (!("ontouchstart" in document.documentElement)) {
        runDefault("animations");
    }

    requestAnimationFrame(() => {
        requestScrollTriggerRefresh(250);
    });
}

function initGlobalScripts() {
    initVariables();
    initScroller();
    runDefault("grid");
    runDefault("link-prefetch");
}

function initLayoutScripts() {
    runLayoutDefault("header");
    runLayoutDefault("nav");
    runLayoutDefault("mbl-nav");
    runLayoutDefault("footer");
}

function initComponentScripts() {
    runComponentDefault("credit", ".credit");
    runComponentDefault("btn-hover", ".btn-hover");
    runComponentDefault("spotlight", ".spotlight");
    runComponentDefault("accordion", ".accordion");
    runComponentDefault("filter-modal", ".filter-modal");
    runComponentDefault("filter-search", ".filter__search");
    runComponentDefault("search-modal", ".search-modal");
    runComponentDefault("video-modal", ".video-modal");
}

function initModuleScripts() {
    runModuleDefault("asset", ".asset--slider");
    runModuleDefault("home-hero", ".home-hero");
    runModuleDefault("study-hero", ".study-hero");
    runModuleDefault("sectors-list", ".sectors__list");
    runModuleDefault("sectors-slider", ".sectors__slider");
    runModuleDefault("people-slider", ".people-slider");
    runModuleDefault("history", ".history");
    runModuleDefault("values", ".values");
    runModuleDefault("circle-hero", ".circle-hero");
    runModuleDefault("contact-hero", ".contact-hero");
    runModuleDefault("hero", ".hero");
    runModuleDefault("detail-hero", ".detail-hero");
    runModuleDefault("service-grid", ".service-grid");
    runModuleDefault("pillars", ".pillars");
    runModuleDefault("latest", ".latest");
    runModuleDefault("key-contacts", ".key-contacts");
    runModuleDefault("image", ".image--slider");

    if (inner.w > breakpoints.lg) {
        runModuleDefault("projects-map", ".listing__map");
        runModuleDefault("projects", ".filter__toggle");
    }
}

function safeInit() {
    requestAnimationFrame(() => setTimeout(init, 1));
}

if (!(document.readyState === "loading")) safeInit();
else document.addEventListener("DOMContentLoaded", safeInit);
